import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { Button, Box } from "@mui/material";
import { CCard, CCardHeader } from "@coreui/react";
import CustomeLoader from "../../components/CustomeLoader";

const AllPartners = () => {
    const navigate = useNavigate();
    const [partners, setPartners] = useState([]);
    const [pending, setPending] = useState(true);
    const [filterType, setFilterType] = useState("delivery");

    useEffect(() => {
        if (!localStorage.getItem("status")) {
            navigate("/");
        }
        fetchPartners(filterType);
    }, [navigate, filterType]);

    const fetchPartners = async (type) => {
        setPending(true);
        try {
            const url =
                type === "delivery"
                    ? "https://dawabajar.encantotech.in/api/get_all_delivery_partner"
                    : "https://dawabajar.encantotech.in/api/get_all_sales_partner";
            const response = await axios.get(url);
            if (response.data.success) {
                setPartners(response.data.data);
            } else {
                Swal.fire("Error", response.data.message || "Failed to fetch partners", "error");
                setPartners([]);
            }
        } catch (error) {
            Swal.fire("Error", "Error fetching partners", "error");
            setPartners([]);
        } finally {
            setPending(false);
        }
    };

    const columns = [
        { name: "#", selector: (row, index) => index + 1, width: "50px" },
        {
            name: "Image",
            selector: (row) =>
                row.image ? (
                    <img
                        src={row.image}
                        alt="Partner"
                        style={{ width: "50px", height: "50px", objectFit: "cover",padding:'5px' }}
                    />
                ) : (
                    "No Image"
                ),
            width: "100px",
        },
        { name: "Name", selector: (row) => row.name, width: "120px" },
        { name: "Username", selector: (row) => row.username, width: "120px" },
        { name: "Email", selector: (row) => row.email, width: "150px" },
        { name: "Phone", selector: (row) => row.phone_number, width: "120px" },

        { name: "State", selector: (row) => row.state?.name || "N/A", width: "100px" },
        { name: "City", selector: (row) => row.city?.name || "N/A", width: "100px" },
        // { name: "Address", selector: (row) => row.address || "N/A", width: "200px" },
        { name: "Status", selector: (row) => row.status, width: "100px" },
        { name: "Type", selector: (row) => row.user_type, width: "100px" },
    ];

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-2 p-0">
                    <Sidebar />
                </div>
                <div className="col-sm-10">
                    <div className="container-fluid">
                        <Navbar />
                        <CCard className="mb-4 ml-3 mt-2">
                            <CCardHeader>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <strong>{filterType === "delivery" ? "Delivery Partners" : "Sales Partners"}</strong>
                                    <Button
                                        variant="contained"
                                        onClick={() => navigate("/register-partner")}
                                        sx={{ backgroundColor: "#16035e" }}
                                    >
                                        Register Partner
                                    </Button>
                                </Box>
                            </CCardHeader>
                            <Box sx={{ p: 2 }}>
                                <Box mb={2}>
                                    <Button
                                        variant={filterType === "delivery" ? "contained" : "outlined"}
                                        onClick={() => setFilterType("delivery")}
                                        sx={{
                                            mr: 2,
                                            backgroundColor: filterType === "delivery" ? "#16035e" : "transparent",
                                            color: filterType === "delivery" ? "#fff" : "#16035e",
                                            borderColor: "#16035e",
                                        }}
                                    >
                                        Delivery Partners
                                    </Button>
                                    <Button
                                        variant={filterType === "sales" ? "contained" : "outlined"}
                                        onClick={() => setFilterType("sales")}
                                        sx={{
                                            backgroundColor: filterType === "sales" ? "#16035e" : "transparent",
                                            color: filterType === "sales" ? "#fff" : "#16035e",
                                            borderColor: "#16035e",
                                        }}
                                    >
                                        Sales Partners
                                    </Button>
                                </Box>
                                <DataTable
                                    columns={columns}
                                    data={partners}
                                    defaultSortFieldId
                                    fixedHeader
                                    responsive
                                    pagination
                                    progressPending={pending}
                                    progressComponent={<CustomeLoader />}
                                />
                            </Box>
                        </CCard>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllPartners;